export var LanguageList = [
    {
        name: "Eng (US)",
        code: "en",
    },
    {
        name: "Spanish",
        code: "es",
    },
    {
        name: "French",
        code: "fr",
    },
    {
        name: "Italian",
        code: "it",
    },
    {
        name: "Malay",
        code: "ms",
    },
    {
        name: "Swedish",
        code: "sv",
    },
    {
        name: "Portuguese",
        code: "pt",
    },
    {
        name: "German",
        code: "de",
    },
    {
        name: "Finnish",
        code: "fi",
    },
    {
        name: "Japanese",
        code: "ja",
    },
];
